import React, { useEffect, useState } from "react";
import axios from "axios";
import SummaryApi from "../common";
import { useParams, useLocation, Link } from "react-router-dom";

const OrderSuccess = () => {
  // read both possible route param names
  const { orderId: paramOrderId, id: paramId } = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  // support route param /order-success/:orderId  OR  /order-success/:id
  // also support query ?id=... or ?orderId=...
  const queryId = query.get("id") || query.get("orderId");
  const orderId = paramOrderId || paramId || queryId;

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orderId) {
      //console.error("No orderId found in params or query.");
      setLoading(false);
      return;
    }

    const fetchOrder = async () => {
      try {
        const res = await axios.get(SummaryApi.getOrderById(orderId));
        setOrder(res.data.order || res.data); // supports backend variations
      } catch (error) {
        //console.error("Failed to load order:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderId]);

  if (loading) return <div style={{ textAlign: "center", marginTop: 50 }}>Loading order details...</div>;
  if (!order) return <div style={{ textAlign: "center", marginTop: 50 }}>Order not found.</div>;

  return (
    <div style={{ maxWidth: 800, margin: "30px auto", padding: "20px" }}>
      <h2 style={{ color: "green" }}>🎉 Thank you — Your Order is Confirmed!</h2>

      <p><strong>Order Number:</strong> {order.orderNumber}</p>
      <p><strong>Order ID:</strong> {order._id}</p>
      <div style={{ marginTop: 10 }}>
        <p><strong>Subtotal:</strong> ₹{order.subtotal ?? order.amount}</p>
        <p><strong>Delivery Charges:</strong> ₹{order.deliveryCharge ?? 0}</p>
        <p><strong>Total Amount Paid:</strong> <strong>₹{order.totalAmount ?? order.amount}</strong></p>
      </div>
      <p><strong>Payment ID:</strong> {order.paymentId || order.transactionDetails?.razorpay_payment_id || "N/A"}</p>
      <p><strong>Payment Status:</strong> {order.paymentStatus || order.status || "Success"}</p>

      <hr />

      <h3>🛒 Items Ordered</h3>
      <ul>
        {order.items?.map((item, index) => (
          <li key={index} style={{ marginBottom: "8px" }}>
            {item.name || item.productName || item.product?.name} × {item.qty} — ₹{Number(item.price ?? (item.product?.price || 0)) * Number(item.qty || 1)}
          </li>
        ))}
      </ul>

      <hr />

      <h3>📦 Shipping Details</h3>
      {order.address ? (
        <>
          <p>{order.address.fullName}</p>
          <p>
            {order.address.addressLine}, {order.address.city} - {order.address.pincode}
          </p>
          <p>Phone: {order.address.phone}</p>
        </>
      ) : (
        <p>No shipping details available.</p>
      )}

      <hr />

      <Link to="/cart" style={{ textDecoration: "none" }}>
        <button
          style={{
            marginTop: 20,
            padding: "10px 20px",
            background: "#4caf50",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Continue Shopping
        </button>
      </Link>
    </div>
  );
};

export default OrderSuccess;
